<yt-fw-default-list-page [CondensedTable]="true"></yt-fw-default-list-page>